import { Action } from "@ngrx/store";
import { BreadcrumbCountryInfo } from "@store/models/breadcrumbInfo.model";

export enum BreadcrumbCountryInfoType {
	SET_SELECTED = "[BreadcrumbCountryInfo] Set Selected"
}
export class UpdateBreadcrumbCountryInfoAction implements Action {
	readonly type = BreadcrumbCountryInfoType.SET_SELECTED;

	//add an optional payload
	constructor(public payload: BreadcrumbCountryInfo) {}
}
export type BreadcrumbCountryInfoAction = UpdateBreadcrumbCountryInfoAction;
